type ValidationResult = string | null;

export const validateRequired = (value: unknown, fieldName: string): ValidationResult => {
  if (value === null || value === undefined || value === '') {
    return `${fieldName}が入力されていません。`;
  }
  return null;
};

export const validateEmail = (email: string): ValidationResult => {
  if (!email) {
    return 'メールアドレスが入力されていません。';
  }
  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
    return 'メールアドレスの形式が正しくありません。';
  }
  return null;
};

export const validateEmailFormat = (email: string): ValidationResult => {
  if (!email) {
    return null;
  }
  if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
    return 'メールアドレスの形式が正しくありません。';
  }
  return null;
};

export const validateEmailOrPhoneNumber = (
  email: string,
  phoneNumber: string
): ValidationResult => {
  if (!email && !phoneNumber) {
    return 'メールアドレスまたは電話番号のいずれかを入力してください。';
  }
  return null;
};

export const validatePassword = (password: string): ValidationResult => {
  if (password.length < 8) {
    return 'パスワードは8文字以上入力してください。';
  }
  if (!(password.match(/([a-zA-Z])/) && password.match(/([0-9])/))) {
    return 'パスワードは英数字混合にしてください。';
  }
  return null;
};

export const validatePasswordConfirmation = (
  password: string,
  confirmation: string
): ValidationResult => {
  if (password !== confirmation) {
    return 'パスワードとパスワード（再入力）が一致しません。';
  }
  return null;
};
